<template>
  <div class="avatar-studio" :id="'studio_' + gender">
    <div class="avatar-studio__head" v-if="!isAvatarGroupWithoutAccessories">
      <ul>
        <li class="avatar-option" v-for="(option, index) in options[gender].categories" :key="index">
          <a href="#" :data-value="option">{{ getTranslatedCategory(option) }}</a>
        </li>
      </ul>
    </div>
    <div class="avatar-studio__main">
      <canvas :class="'canvas_avatar canvas_avatar--' + gender"  width="250" height="250"></canvas>
      <div class="avatar-studio__main__nav studio_nav">
        <a href="" class="prev" data-value="prev"><i class="icon-arrow-left"></i></a>
        <a href="" class="next" data-value="next"><i class="icon-arrow-right"></i></a>
      </div>
      <div class="avatar-options">
        <div class="avatar-options__items hair">
          <img v-if="projectAvatarsMethod(hd)" v-for="(hd, index) in getOptions('hair')" :key="index" :data-value="hd.data" :data-gender="gender" alt="" :src="getImage(hd.name)">
        </div>
        <div class="avatar-options__items skin">
          <img v-if="projectAvatarsMethod(sd)" v-for="(sd, index) in getOptions('skin')" :key="index" :data-value="sd.data" :data-gender="gender" alt="" :src="getImage(sd.name)">
        </div>
        <div class="avatar-options__items accessory" v-if="!isAvatarGroupWithoutAccessories">
          <img v-if="projectAvatarsMethod(ad)" v-for="(ad, index) in options[gender].accessories" :key="index" :data-value="ad.data" :data-gender="gender" alt="" :src="getImage(ad.name)" width="250" height="250">
        </div>
        <div :class="['avatar-options__items', options[gender].categories[3]]">
          <img v-if="projectAvatarsMethod(spd)" v-for="(spd, index) in options[gender].special" :key="index" :data-value="spd.data" :data-gender="gender" alt="" :src="getImage(spd.name)" width="250" height="250">
        </div>
      </div>
    </div>
    <a href="#" class="btn btn--medium btn--main save-btn">
      {{ getTranslations.home_profile_profile_edit_personalize_avatar_save }}
    </a>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'avatar',
  props: {
    gender: String,
  },
  data() {
    return {
      options: {
        male: {
          categories: ['hair', 'skin', 'accessory', 'mustage'],
          hair: {
            custom: [
              { name: 'avatars/male_hair_white', data: 'white', filter_groups: [2, 3, 7, 10] },
              { name: 'avatars/male_hair_white2', data: 'white2', filter_groups: [5, 7, 10] },
              { name: 'avatars/male_hair_black', data: 'black', filter_groups: [7, 10] },
              { name: 'avatars/male_hair_black2', data: 'black2', filter_groups: [2, 3, 5, 7, 10] },
              { name: 'avatars/male_hair_black3', data: 'black3', filter_groups: [2, 7, 10] },
              { name: 'avatars/male_hair_black4', data: 'black4', filter_groups: [5, 7, 8, 10] },
              { name: 'avatars/male_hair_black5', data: 'black5', filter_groups: [1, 4, 7, 8, 10] },
              { name: 'avatars/male_hair_black6', data: 'black6', filter_groups: [1, 4, 7, 8, 10] },
              { name: 'avatars/male_hair_black7', data: 'black7', filter_groups: [1, 4, 7, 8, 10] },
              { name: 'avatars/male_hair_black8', data: 'black8', filter_groups: [1, 3, 4, 7, 8, 10] },
              { name: 'avatars/male_hair_brown', data: 'brown', filter_groups: [7, 8, 10] },
              { name: 'avatars/male_hair_brown2', data: 'brown2', filter_groups: [7, 8, 10] },
              { name: 'avatars/male_hair_brown3', data: 'brown3', filter_groups: [7, 8, 10] },
              { name: 'avatars/male_hair_brown4', data: 'brown4', filter_groups: [1, 4, 7, 8, 10] },
              { name: 'avatars/male_hair_brown5', data: 'brown5', filter_groups: [1, 4, 5, 7, 8, 10] },
              { name: 'avatars/male_hair_hat1', data: 'hat1', filter_groups: [1, 3, 4, 5, 7, 8, 10] },
              { name: 'avatars/male_hair_hat2', data: 'hat2', filter_groups: [1, 3, 4, 5, 7, 8, 9, 10] },
              { name: 'avatars/male_hair_hat3', data: 'hat3', filter_groups: [1, 3, 4, 5, 7, 8, 10] },
              { name: 'avatars/male_hair_keffiyeh', data: 'hair_keffiyeh', filter_groups: [2, 3, 7, 8, 10] },
              { name: 'avatars/male_hair_white_keffiyeh', data: 'white_keffiyeh', filter_groups: [2, 3, 7, 8, 10] },
              { name: 'avatars/male_hair_black_keffiyeh', data: 'black_keffiyeh', filter_groups: [2, 3, 6, 7, 8, 10] },
              { name: 'avatars/male_hair_blonde', data: 'blonde', filter_groups: [1, 2, 3, 4, 5, 7, 8, 10] },
              { name: 'avatars/male_hair_red', data: 'red', filter_groups: [1, 2, 3, 4, 5, 7, 8, 10] },
              { name: 'avatars/male_hair_turban', data: 'turban', filter_groups: [1, 2, 3, 4, 5, 6, 7, 8, 10] },
              { name: 'avatars/male_hair_turban2', data: 'turban2', filter_groups: [1, 3, 4, 5, 6, 7, 8, 10] },
            ],
            grouping: [
              { name: 'avatar_7/male/Avatar_1.jpg', data: 'single' },
              { name: 'avatar_7/male/Avatar_2.jpg', data: 'color1' },
              { name: 'avatar_7/male/Avatar_3.jpg', data: 'color2' },
              { name: 'avatar_7/male/Avatar_4.jpg', data: 'color3' },
              { name: 'avatar_7/male/Avatar_5.jpg', data: 'color4' },
              { name: 'avatar_7/male/Avatar_6.jpg', data: 'color5' },
              { name: 'avatar_7/male/Avatar_7.jpg', data: 'color6' },
              { name: 'avatar_7/male/Avatar_8.jpg', data: 'sleeves' },
            ],
            default: [
              { name: 'avatar_10/male/Avatar_1.jpg', data: 'single' },
              { name: 'avatar_10/male/Avatar_2.jpg', data: 'color1' },
              { name: 'avatar_10/male/Avatar_3.jpg', data: 'color2' },
              { name: 'avatar_10/male/Avatar_4.jpg', data: 'color3' },
              { name: 'avatar_10/male/Avatar_5.jpg', data: 'color4' },
              { name: 'avatar_10/male/Avatar_6.jpg', data: 'color5' },
              { name: 'avatar_10/male/Avatar_7.jpg', data: 'color6' },
            ],
          },
          skin: {
            custom: [
              { name: 'avatars/male_white', data: 'white', filter_groups: [7, 10] },
              { name: 'avatars/male_white2', data: 'white2', filter_groups: [1, 4, 7, 10] },
              { name: 'avatars/male_black', data: 'black', filter_groups: [7, 10] },
              { name: 'avatars/male_black2', data: 'black2', filter_groups: [1, 4, 7, 10] },
              { name: 'avatars/male_dark_black', data: 'dark_black', filter_groups: [6, 7, 10] },
              { name: 'avatars/male_dark_black2', data: 'dark_black2', filter_groups: [1, 4, 6, 7, 10] },
            ],
            grouping: [{ name: 'avatar_7/male/Avatar_1.jpg', data: 'white' }],
            default: [{ name: 'avatar_10/male/Avatar_1.jpg', data: 'white' }],
          },
          accessories: [
            { name: 'avatars/male_accessory1', data: 'accessory1', filter_groups: [7, 10] },
            { name: 'avatars/male_accessory2', data: 'accessory2', filter_groups: [7, 10] },
            { name: 'avatars/male_accessory3', data: 'accessory3', filter_groups: [7, 8, 10] },
            { name: 'avatars/male_accessory4', data: 'accessory4', filter_groups: [7, 8, 10] },
            { name: 'avatars/male_accessory5', data: 'accessory5', filter_groups: [7, 10] },
            { name: 'avatars/male_accessory6', data: 'accessory6', filter_groups: [7, 8, 10] },
            { name: 'avatars/male_accessory7', data: 'accessory7', filter_groups: [7, 8, 10] },
            { name: 'avatars/male_accessory8', data: 'accessory8', filter_groups: [7, 8, 10] },
          ],
          special: [
            { name: 'avatars/male_mustage_brown1', data: 'brown1', filter_groups: [1, 2, 4, 5, 7, 8, 10] },
            { name: 'avatars/male_mustage_brown2', data: 'brown2', filter_groups: [1, 4, 7, 8, 10] },
            { name: 'avatars/male_mustage_brown3', data: 'brown3', filter_groups: [7, 8, 10] },
            { name: 'avatars/male_mustage_brown4', data: 'brown4', filter_groups: [7, 8, 10] },
            { name: 'avatars/male_mustage_brown5', data: 'brown5', filter_groups: [1, 2, 3, 4, 5, 7, 8, 10] },
            { name: 'avatars/male_mustage_brown6', data: 'brown6', filter_groups: [7, 8, 10] },
            { name: 'avatars/male_mustage_black1', data: 'black1', filter_groups: [7, 8, 10] },
            { name: 'avatars/male_mustage_black2', data: 'black2', filter_groups: [2, 3, 7, 8, 10] },
            { name: 'avatars/male_mustage_black3', data: 'black3', filter_groups: [1, 2, 3, 4, 5, 7, 10] },
            { name: 'avatars/male_mustage_black4', data: 'black4', filter_groups: [1, 2, 4, 7, 8, 10] },
            { name: 'avatars/male_mustage_black5', data: 'black5', filter_groups: [1, 2, 4, 7, 8, 10] },
            { name: 'avatars/male_mustage_black6', data: 'black6', filter_groups: [3, 7, 10] },
            { name: 'avatars/male_mustage_black7', data: 'black7', filter_groups: [1, 4, 7, 8, 10] },
            { name: 'avatars/male_mustage_black8', data: 'black8', filter_groups: [1, 4, 5, 6, 7, 8, 10] },
            { name: 'avatars/male_mustage_black9', data: 'black9', filter_groups: [1, 5, 7, 8, 10] },
            { name: 'avatars/male_mustage_white1', data: 'white1', filter_groups: [1, 2, 4, 5, 7, 8, 10] },
            { name: 'avatars/male_mustage_white2', data: 'white2', filter_groups: [1, 3, 4, 5, 7, 8, 10] },
            { name: 'avatars/male_mustage_white3', data: 'white3', filter_groups: [1, 2, 3, 4, 5, 7, 8, 10] },
            { name: 'avatars/male_mustage_white4', data: 'white4', filter_groups: [1, 2, 4, 7, 8, 10] },
            { name: 'avatars/male_mustage_white5', data: 'white5', filter_groups: [2, 3, 7, 10] },
            { name: 'avatars/male_mustage_white6', data: 'white6', filter_groups: [2, 7, 8, 10] },
            { name: 'avatars/male_mustage_blonde1', data: 'blonde1', filter_groups: [1, 2, 3, 4, 5, 7, 8, 10] },
            { name: 'avatars/male_mustage_blonde2', data: 'blonde2', filter_groups: [1, 2, 3, 4, 5, 7, 8, 10] },
            { name: 'avatars/male_mustage_blonde3', data: 'blonde3', filter_groups: [1, 2, 3, 4, 5, 7, 8, 10] },
            { name: 'avatars/male_mustage_blonde4', data: 'blonde4', filter_groups: [1, 2, 3, 4, 5, 7, 8, 10] },
            { name: 'avatars/male_mustage_blonde5', data: 'blonde5', filter_groups: [1, 2, 3, 4, 5, 7, 8, 10] },
            { name: 'avatars/male_mustage_red1', data: 'red1', filter_groups: [1, 2, 3, 4, 5, 7, 8, 10] },
            { name: 'avatars/male_mustage_red2', data: 'red2', filter_groups: [1, 2, 3, 4, 5, 7, 8, 10] },
            { name: 'avatars/male_mustage_red3', data: 'red3', filter_groups: [1, 2, 3, 4, 5, 7, 8, 10] },
            { name: 'avatars/male_mustage_red4', data: 'red4', filter_groups: [1, 2, 3, 4, 5, 7, 8, 10] },
            { name: 'avatars/male_mustage_red5', data: 'red5', filter_groups: [1, 2, 3, 4, 5, 7, 8, 10] },
          ],
        },
        female: {
          categories: ['hair', 'skin', 'accessory', 'jewellery'],
          hair: {
            custom: [
              { name: 'avatars/female_hair_blackhijab', data: 'blackhijab', filter_groups: [3, 5, 6, 8, 7, 10] },
              { name: 'avatars/female_hair_black', data: 'black', filter_groups: [2, 7, 10] },
              { name: 'avatars/female_hair_black_2', data: 'black_2', filter_groups: [2, 7, 8, 10] },
              { name: 'avatars/female_hair_black_3', data: 'black_3', filter_groups: [2, 7, 10] },
              { name: 'avatars/female_hair_brown', data: 'brown', filter_groups: [1, 4, 7, 10] },
              { name: 'avatars/female_hair_brown_2', data: 'brown_2', filter_groups: [2, 7, 8, 10] },
              { name: 'avatars/female_hair_brown_3', data: 'brown_3', filter_groups: [2, 5, 7, 8, 10] },
              { name: 'avatars/female_hair_brown_4', data: 'brown_4', filter_groups: [2, 5, 7, 8, 9, 10] },
              { name: 'avatars/female_hair_brown_5', data: 'brown_5', filter_groups: [2, 5, 6, 7, 8, 10] },
              { name: 'avatars/female_hair_brown_6', data: 'brown_6', filter_groups: [2, 5, 7, 10] },
              { name: 'avatars/female_hair_brown_7', data: 'brown_7', filter_groups: [2, 5, 7, 8, 10] },
              { name: 'avatars/female_hair_white', data: 'white', filter_groups: [2, 7, 8, 10] },
              { name: 'avatars/black_hijab', data: 'black_hijab', filter_groups: [2, 3, 6, 7, 10] },
              { name: 'avatars/grey_hijab', data: 'grey_hijab', filter_groups: [3, 6, 7, 8, 10] },
              { name: 'avatars/blue_hijab', data: 'blue_hijab', filter_groups: [3, 6, 7, 8, 10] },
              { name: 'avatars/blue_hijab_2', data: 'blue_hijab_2', filter_groups: [1, 2, 3, 4, 5, 6, 7, 8, 10] },
              { name: 'avatars/blue_hijab_3', data: 'blue_hijab_3', filter_groups: [1, 3, 4, 6, 7, 8, 10] },
              { name: 'avatars/pink_hijab', data: 'pink_hijab', filter_groups: [1, 2, 3, 4, 5, 6, 7, 8, 10] },
              { name: 'avatars/purple_hijab', data: 'purple_hijab', filter_groups: [1, 2, 3, 4, 5, 6, 7, 8, 10] },
              { name: 'avatars/red_hijab', data: 'red_hijab', filter_groups: [1, 2, 3, 4, 5, 6, 7, 8, 10] },
              { name: 'avatars/floral_hijab', data: 'floral_hijab', filter_groups: [1, 3, 4, 7, 8, 10] },
              { name: 'avatars/floral_khimar', data: 'floral_khimar', filter_groups: [1, 3, 4, 7, 8, 10] },
              { name: 'avatars/floral_khimar_2', data: 'floral_khimar_2', filter_groups: [1, 3, 4, 7, 8, 10] },
              { name: 'avatars/mustard_hijab', data: 'mustard_hijab', filter_groups: [1, 3, 4, 7, 8, 10] },
              { name: 'avatars/pink_khimar', data: 'pink_khimar', filter_groups: [1, 3, 4, 5, 7, 8, 10] },
              { name: 'avatars/red_hijab_2', data: 'red_hijab_2', filter_groups: [1, 3, 4, 5, 7, 8, 10] },
              { name: 'avatars/white_hijab', data: 'white_hijab', filter_groups: [1, 3, 4, 5, 7, 8, 10] },
              { name: 'avatars/white_hijab_2', data: 'white_hijab_2', filter_groups: [1, 3, 4, 5, 7, 8, 10] },
            ],
            grouping: [
              { name: 'avatar_7/female/Avatar_1.jpg', data: 'single' },
              { name: 'avatar_7/female/Avatar_2.jpg', data: 'color1' },
              { name: 'avatar_7/female/Avatar_3.jpg', data: 'color2' },
              { name: 'avatar_7/female/Avatar_4.jpg', data: 'color3' },
              { name: 'avatar_7/female/Avatar_5.jpg', data: 'color4' },
              { name: 'avatar_7/female/Avatar_6.jpg', data: 'color5' },
              { name: 'avatar_7/female/Avatar_7.jpg', data: 'color6' },
              { name: 'avatar_7/female/Avatar_8.jpg', data: 'sleeves' },
            ],
            default: [
              { name: 'avatar_10/female/Avatar_1.jpg', data: 'single' },
              { name: 'avatar_10/female/Avatar_2.jpg', data: 'color1' },
              { name: 'avatar_10/female/Avatar_3.jpg', data: 'color2' },
              { name: 'avatar_10/female/Avatar_4.jpg', data: 'color3' },
              { name: 'avatar_10/female/Avatar_5.jpg', data: 'color4' },
              { name: 'avatar_10/female/Avatar_6.jpg', data: 'color5' },
              { name: 'avatar_10/female/Avatar_7.jpg', data: 'color6' },
              { name: 'avatar_10/female/Avatar_8.jpg', data: 'sleeves' },
              { name: 'avatar_10/female/Avatar_9.jpg', data: 'sleeves1' },
            ],
          },
          skin: {
            custom: [
              { name: 'avatars/female_white', data: 'white', filter_groups: [7, 10] },
              { name: 'avatars/female_white2', data: 'white2', filter_groups: [1, 4, 7, 10] },
              { name: 'avatars/female_black', data: 'black', filter_groups: [7, 10] },
              { name: 'avatars/female_black2', data: 'black2', filter_groups: [1, 4, 7, 10] },
              { name: 'avatars/female_dark_black', data: 'dark_black', filter_groups: [6, 7, 10] },
              { name: 'avatars/female_dark_black2', data: 'dark_black2', filter_groups: [1, 4, 7, 10] },
            ],
            grouping: [{ name: 'avatar_7/female/Avatar_1.jpg', data: 'white' }],
            default: [{ name: 'avatar_10/female/Avatar_1.jpg', data: 'white' }],
          },
          accessories: [
            { name: 'avatars/female_accessory1', data: 'accessory1', filter_groups: [7, 10] },
            { name: 'avatars/female_accessory2', data: 'accessory2', filter_groups: [7, 8, 10] },
            { name: 'avatars/female_accessory3', data: 'accessory3', filter_groups: [7, 10] },
            { name: 'avatars/female_accessory4', data: 'accessory4', filter_groups: [7, 8, 10] },
            { name: 'avatars/female_accessory5', data: 'accessory5', filter_groups: [7, 8, 10] },
            { name: 'avatars/female_accessory6', data: 'accessory6', filter_groups: [7, 10] },
            { name: 'avatars/female_accessory7', data: 'accessory7', filter_groups: [7, 10] },
            { name: 'avatars/female_accessory8', data: 'accessory8', filter_groups: [7, 8, 10] },
          ],
          special: [
            { name: 'avatars/female_jewellery1', data: 'jewellery1', filter_groups: [7, 8, 10] },
            { name: 'avatars/female_jewellery2', data: 'jewellery2', filter_groups: [7, 8, 10] },
            { name: 'avatars/female_jewellery3', data: 'jewellery3', filter_groups: [7, 10] },
            { name: 'avatars/female_jewellery4', data: 'jewellery4', filter_groups: [7, 10] },
            { name: 'avatars/female_jewellery5', data: 'jewellery5', filter_groups: [7, 10] },
            { name: 'avatars/female_jewellery6', data: 'jewellery6', filter_groups: [7, 8, 10] },
            { name: 'avatars/female_jewellery7', data: 'jewellery7', filter_groups: [7, 8, 10] },
            { name: 'avatars/female_jewellery8', data: 'jewellery8', filter_groups: [7, 8, 10] },
            { name: 'avatars/female_jewellery9', data: 'jewellery9', filter_groups: [1, 4, 7, 10] },
            { name: 'avatars/female_jewellery10', data: 'jewellery10', filter_groups: [1, 4, 7, 8, 10] },
          ],
        },
      },
    };
  },
  methods: {
    getTranslatedCategory(option) {
      return this.getTranslations[`home_profile_profile_edit_personalize_avatar_${option}`];
    },
    getMessage(key) {
      return this.getTranslations[key] || '';
    },
    getOptions(category) {
      if (!this.isAvatarGroupWithoutAccessories) {
        return this.options[this.gender][category].custom;
      } else if (this.avatarGrouping === 7) {
        return this.options[this.gender][category].grouping;
      }
      return this.options[this.gender][category].default;
    },
    projectAvatarsMethod(avatarData) {
      if (!this.isAvatarGroupWithoutAccessories || this.avatarGrouping === 7) return true;
      return avatarData.filter_groups.indexOf(this.avatarGrouping) === -1;
    },
    getImage(name) {
      return `static/images/${name}${name.includes('.jpg') ? '' : '.png'}`;
    },
  },
  computed: {
    ...mapState('common', [
      'avatarGrouping',
      'userDetails',
      'isAvatarGroupWithoutAccessories',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/Avatar.vue